<nav class="navbar navbar-light bg-light navbar-expand-lg">
    <form class="form-inline flex-fill" id="formularioFiltros">
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <ul class="navbar-nav ms-2 me-auto">
            <!--buscador -->
            <li class="nav-item me-2">
                <div class="nav-item">
                    <input id="busquedaFormControl" appOnlyNumber class="form-control" placeholder="Buscador"
                        [formControl]="busquedaFormControl" (input)="filtrarAerovales()" />
                </div>
            </li>

            <div ngbDropdown autoClose="outside">
                <button [disabled]="this.cargandoAerovales" type="button"
                    class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" id="dropdownForm1"
                    ngbDropdownToggle>Aeroplantas</button>
                <div class="limitar" ngbDropdownMenu aria-labelledby="dropdownForm1">
                    <div class="px-4 py-3">
                        <div class="form-check">
                            <div *ngFor="let a of this.aeroplantas; let i = index;">
                                <input type="checkbox" name="Aeroplantas+{{i}}" class="form-check-input"
                                    id="{{ 'dropdownCheck' + i}}" [(ngModel)]="a.seleccionada"
                                    [ngModelOptions]="{standalone: true}" (change)="filtrarAerovalesPorAeroplanta()">
                                <label class="form-check-label text-nowrap"
                                    for="{{ 'dropdownCheck' + i}}">
                                    {{ a.nombre }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <li class="nav-item me-2">
                <div class="input-group">
                    <input type="date" [ngModel]="modelDesde" class="fechaFormControlDesdeHasta"
                        placeholder="aaaa-mm-dd" (ngModelChange)="modelDesde = $event" name="dt" ngbDatepicker
                        #d="ngbDatepicker" value="model" class="form-control form-control-rounded" #id="ngbDatepicker"
                        #searchDate required readonly>

                    <div class="input-group-append">
                        <button id="botonDesde" type="button" class="input-group-btn btn btn-secondary"
                            (click)="toggleDatepicker(d)">
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </li>

            <li class="nav-item me-2">
                <div class="input-group">
                    <input type="date" [ngModel]="modelHasta" class="fechaFormControlDesdeHasta"
                        placeholder="aaaa-mm-dd" (ngModelChange)="modelHasta = $event" name="dt" ngbDatepicker
                        #h="ngbDatepicker" value="model" class="form-control form-control-rounded" #id="ngbDatepicker"
                        #searchDate required readonly>

                    <div class="input-group-append">
                        <button id="botonDesde" type="button" class="input-group-btn btn btn-secondary"
                            (click)="toggleDatepicker(h)">
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </li>

            <li class="nav-item me-2">
                <button [disabled]="cargandoAerovales" class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2"
                    (click)="filtrarAerovalesPorFecha()"><i class="fa fa-search" aria-hidden="true"></i>
                </button>
            </li>
            
            <li class="nav-item ms-auto me-2">
                <button [disabled]="cargandoAerovales" class="btn btn-outline-success" (click)="descargarExcel()">
                    <span> Descargar <i
                        class="fa fa-file-excel-o fa-lg" aria-hidden="true"></i></span>
                  </button>
            </li>
        </ul>
            
    </form>
</nav>
<div class="col container-fluid">
    <div class="spinner-container" *ngIf="this.cargandoAerovales">
        <ngx-spinner name="spinnerLista"[ngStyle]="{'height': '400px', 'z-index':'0'}"
        [ngClass]="{'list-group-item list-group-item-action': cargandoAerovales}" bdOpacity=0.3bd Color="rgba(193,193,193,0)" size="medium" color="#185db5"
            type="ball-grid-beat" [fullScreen]="false">
            <p style="color: white"> C a r g a n d o . . . </p>
        </ngx-spinner>
    </div>

    <table *ngIf="!this.cargandoAerovales && this.aerovales.length !== 0" class="table table-striped">
        <thead>
            <tr>
                <th scope="col">
                    <p class="text-center text-nowrap">
                        Aeroplanta
                    </p>
                </th>

                <th scope="col">
                    <p class="text-center text-nowrap">
                        Aerovale
                    </p>
                </th>

                <th scope="col">
                    <p class="text-center text-nowrap">
                        Aerovale reemplazo
                    </p>
                </th>

                <th scope="col">
                    <p class="text-center text-nowrap">
                        Fecha y hora
                    </p>
                </th>

                <th scope="col">
                    <p class="text-center text-nowrap">
                        Estado
                    </p>
                </th>

                <th scope="col">
                    <p class="text-center text-nowrap">
                        Facturado
                    </p>
                </th>

                <th scope="col">
                    <p class="ml-3 text-center text-nowrap">
                        Refacturado
                    </p>
                </th>

                <th scope="col">
                    <p class="ml-3 text-center text-nowrap">
                        Condición de venta
                    </p>
                </th>

                <th scope="col">
                    <p class="text-center text-nowrap ml-1">
                        Efectivo
                    </p>
                </th>

                <th scope="col">
                    <p class="text-center text-nowrap">
                        Operador
                    </p>
                </th>

                <th scope="col">
                    <p class="text-center text-nowrap">
                        Observación
                    </p>
                </th>

                <th scope="col">
                    <p class="text-center text-nowrap">
                        Comentario
                    </p>
                </th>

                <th scope="col">
                    <p class="text-center text-nowrap">
                        Aerovale
                    </p>
                </th>

                <th scope="col">
                    <p class="ml-3 text-center text-nowrap">
                        Factura
                    </p>
                </th>

                <th scope="col">
                    <p class="text-center text-nowrap ml-1">
                        Nota D/C
                    </p>
                </th>

            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let a of aerovales">
                <td>
                    <div class="text-center">{{a.aeroplanta.nombre}}
                    </div>
                </td>
                <td>
                    <div class="text-center">{{a.numeroAerovale}}
                    </div>
                </td>
                <td>
                    <div class="text-center">{{a.numeroAerovaleReemplazo ? a.numeroAerovaleReemplazo : '--'}}
                    </div>
                </td>
                <td>
                    <div class="text-center">{{fechaValida(a.fechaHoraMovimiento)}}
                    </div>
                </td>
                <td>
                    <div class="text-center">{{getEstado(a.aerovale.estado)}}
                    </div>
                </td>
                <td>
                    <div class="text-center">{{a.facturado ? 'Si' : 'No'}}
                    </div>
                </td>
                <td>
                    <div class="text-center">{{a.refacturado ? 'Si': 'No'}}
                    </div>
                </td>
                <td>
                    <div class="text-center">{{ a.condicionDeVenta }}
                    </div>
                </td>
                <td>
                    <div class="text-center">{{a.efectivo ? a.efectivo : '--'}}
                    </div>
                </td>
                <td>
                    <div class="text-center">{{getOperador(a.operadorDTO)}}
                    </div>
                </td>
                <td>
                    <div class="text-center">{{ a.observacion ? a.observacion : '--' }}
                    </div>
                </td>
                <td class="text-center">
                    <button [disabled]="cargandoComprobante" *ngIf="a.comentario" class="btn btn-link" style="color: black" (click)="this.mostrarComentario(a.comentario)" placement="bottom"
                        ngbTooltip="Ver Comentario" container="body">
                        <i class="fa fa-eye" aria-hidden="true"></i>
                    </button>
                    <div class="text-center" *ngIf="!a.comentario">--</div>
                </td>
                <td class="text-center">
                    <button [disabled]="cargandoComprobante" class="btn btn-link" style="color: black" (click)="this.mostrarAerovale(a.aerovale.id)" placement="bottom" ngbTooltip="Ver Aerovale"
                        container="body">
                        <i class="fa fa-eye" aria-hidden="true"></i>
                    </button>
                </td>
                <td class="text-center">
                    <div *ngIf="a.facturado">
                        <button [disabled]="cargandoComprobante" class="btn btn-link" style="color: black" (click)="this.obtenerComprobanteId(a.aerovale.id)" placement="bottom"
                            ngbTooltip="Ver Factura" container="body" *ngIf="puedeVerFactura(a)">
                            <i class="fa fa-eye" aria-hidden="true"></i>
                        </button>
                        <p *ngIf="!puedeVerFactura(a)">
                            --
                        </p>
                    </div>
                    <div *ngIf="!a.facturado">--</div>
                </td> 
                <td class="text-center">
                    <div *ngIf="a.nota">
                        <button [disabled]="cargandoComprobante" class="btn btn-link" style="color: black"(click)="this.mostrarNota(a.aerovale.id)" placement="bottom"
                            ngbTooltip="Ver Nota D/C" container="body" *ngIf="puedeVerFactura(a)">
                            <i class="fa fa-eye" aria-hidden="true"></i>
                        </button>
                        <p *ngIf="!puedeVerFactura(a)">
                            --
                        </p>
                    </div>
                    <div *ngIf="!a.nota"> -- </div>
                </td>
            </tr>

        </tbody>

    </table>
</div>